// Helperfunctions for enroute map filter

import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax

import '../../style/map.scss';
import {
  fetchTAFV2,
  fetchMETAR,
  fetchCoordinatesFromICAO,
  getNOTAMListFromAllData,
} from '../helperfunctions';

// Used for Enroute filters
// Gets coordinates of an airport by requesting using an icao thorugh aviation weathers api
// Plots color coded markers out on the map based on flight category
export function addEnrouteAirports(
  map,
  data,
  markerList,
  handleOpenAirportModal,
) {
  const notamList = getNOTAMListFromAllData(data);

  // Collect all enroute airport ICAOs (skip first two which are dep and arr)
  const enrouteICAOs = data.WXT_List[0]?.string?.slice(2) || [];

  if (enrouteICAOs.length === 0) return;

  // Batch fetch all data in single requests
  const icaoString = enrouteICAOs.join(',');

  // Fetch all data in parallel (using V2 endpoint for JSON TAF format)
  Promise.all([
    fetchCoordinatesFromICAO(icaoString).then((res) => res.json()),
    fetchTAFV2(icaoString).then((res) => res.json()),
    fetchMETAR(icaoString).then((res) => res.json()),
  ])
    .then(([coordinatesData, tafData, metarData]) => {
      if (!coordinatesData || !Array.isArray(coordinatesData)) return;

      // Extract METAR array from XML response structure
      const metarArray = metarData?.[0]?.METAR || [];

      // Process each airport
      enrouteICAOs.forEach((airportICAO) => {
        // Find the data for this ICAO
        const airportData = coordinatesData.find(
          (airport) => airport.icaoId === airportICAO
        );

        if (!airportData) return;

        const airportName = airportData.name || 'Airport name not found';
        const airportIATA = airportData.iataId || airportICAO; // Fallback to ICAO if no IATA
        const airportLng = airportData.lon || 'Airport longitude not found';
        const airportLat = airportData.lat || 'Airport latitude not found';

        // Find TAF data for this ICAO (JSON format)
        const tafInfo = tafData?.find((taf) => taf.icaoId === airportICAO);
        const airportTAF = tafInfo?.rawTAF || 'TAF data not found';

        // Find METAR data for this ICAO (XML format from backend)
        const metarInfo = metarArray.find((metar) => metar.station_id?.[0] === airportICAO);
        // Modal expects raw_text as string (not array), so convert it
        const airportMETAR = metarInfo ? {
          ...metarInfo,
          raw_text: metarInfo.raw_text?.[0] || ''
        } : null;
        const flightCategory = metarInfo?.flight_category?.[0] || 'Flight category data not found';

        const markerElement = document.createElement('div');

        // color of marker based on the color category (data is from metar fetch)
        if (flightCategory === 'LIFR') {
          markerElement.className = 'marker-brown-magenta';
        } else if (flightCategory === 'IFR') {
          markerElement.className = 'marker-brown-red';
        } else if (flightCategory === 'MVFR') {
          markerElement.className = 'marker-brown-blue';
        } else if (flightCategory === 'VFR') {
          markerElement.className = 'marker-brown-green';
        } else {
          markerElement.className = 'marker-brown';
        }

        // add marker to map
        const marker = new mapboxgl.Marker(markerElement)
          .setLngLat([airportLng, airportLat])
          .addTo(map.current);
        markerElement.onclick = () =>
          handleOpenAirportModal(
            airportName,
            airportIATA,
            airportMETAR,
            airportTAF,
            airportICAO,
            notamList
          );

        markerList.push(marker);
      });
    })
    .catch((error) => {
      console.error('Error fetching airport data:', error);
    });
}
